import {CommonService} from '../../services/common.service';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {ISalePoint} from '../../models/models';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatOption} from '@angular/material';
import {SelectionDialogComponent} from './selection-dialog/selection-dialog.component';
import {ToastMessagesService} from '../../services/toast-messages.service';

interface User {
  id: number;
  name: string;
  sales_group_names?: any;
}

interface Role {
  id: number;
  name: string;
  alternate_name: string;
  is_mobile_user: number;
  totalUsers?: User[];
  selectedUsers?: User[];
  selectedSalePoints?: any[];
  salePointsForRemoval?: any[];
  usersForRemoval?: any[];
}

@Component({
  templateUrl: './assing-questionnaire-dialog.component.html'
})
export class AssingQuestionnaireDialogComponent implements OnInit {
  categoryId: number;
  statusId: number;
  details: any;
  title: string;
  mode: number;
  roles: Role[];
  selectedRole: Role;
  loadingRoles: boolean;
  salePoints: ISalePoint[];
  loadingSalePoints: boolean;
  users: User[];
  loading: boolean;
  loadingUsers: boolean;
  buttonMessage: string;
  dataSP: any;
  detailsId: number;
  @ViewChild('allSelected', {static: true}) private allSelected: MatOption;

  constructor(private commonService: CommonService,
              private matDialog: MatDialog,
              private matDialogRef: MatDialogRef<AssingQuestionnaireDialogComponent>,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    // this.details = data.details ? data.details : null;
    this.detailsId = data.detailsId;
    this.categoryId = data.categoryId;
    this.statusId = data.statusId;
    this.loadingRoles = false;
    this.loading = false;
    this.loadingSalePoints = false;
    this.loadingUsers = false;
    this.title = data.title;
    this.mode = data.mode;
    this.buttonMessage = data.mode === 0 ? 'Ανάθεση' : 'Ενημέρωση';
  }

  public async ngOnInit(): Promise<any> {
    await this.initRoles();

    if (this.mode === 1) {
      this.details = await this.fetchRoutingDetails();
    }

    if (this.details && this.mode === 1) {
      // await this.distributeSelectedUsersToRoles();
      await this.distributeUsersToRoles();
    }
  }

  //#region initialization async calls
  async fetchRoutingDetails() {
    try {
      return await this.commonService.getList(`questionnaire/routed/${this.detailsId}`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initRoles() {
    return new Promise((async resolve => {
      const promises = [];
      try {
        this.loadingRoles = true;
        this.loading = true;

        if (this.categoryId === 3) {
          this.roles = await this.commonService.getListWithParameters(`role`, `is_mobile_user=1`) as Role[];
        } else {
          this.roles = await this.commonService.getListWithParameters(`role`, `id=4 OR id=5 OR id=6 OR id=7 OR id=8 OR id=9`) as Role[];
        }

        for (const role of this.roles) {
          role.totalUsers = [];
          role.selectedUsers = [];
          role.selectedSalePoints = [];
          const promise = new Promise((resolution) => {
            this.commonService.getListWithParameters(`user`, `role_id=${role.id}`).then((result: User[]) => {
              role.totalUsers = result;
              resolution();
            });
          });
          promises.push(promise);
        }

        Promise.all(promises).then(() => {
          resolve();
        });
      } catch (e) {
        this.showError(e);
      } finally {
        this.loading = false;

        this.loadingRoles = false;
      }
    }));
  }

  async initUsers() {
    try {
      this.loadingUsers = true;
      this.users = await this.commonService.getListWithParameters(`user`, `role_id=${this.selectedRole.id}`) as User[];
    } catch (e) {
      this.showError(e);
    } finally {
      this.loadingUsers = false;
    }
  }


  //#endregion

  async distributeUsersToRoles() {
    return new Promise(resolve => {
      const promises = [];
      for (const detailsUser of this.details.users) {
        const promise = new Promise(async resolution => {
          const detailsUserRole = this.roles.find(role => role.id === detailsUser.role_id);
          if (detailsUserRole) {
            const user = detailsUserRole.totalUsers.find(u => u.id === detailsUser.id);
            if (user) {
              detailsUserRole.selectedUsers.push(user);
              let filter;
              filter = detailsUserRole.id === 4 ? 'inspector_id' : detailsUserRole.id === 5 ? 'regional_id' : 'user_id';
              filter += ` = ${user.id}`;
              if (this.categoryId !== 3) {
                this.dataSP = await this.commonService.getListWithParameters(`sale_point/simple`, `${filter}`);
                for (const salePoint of detailsUser.sale_points) {
                  const currentSP = this.dataSP.find(sp => sp.id === salePoint.id);
                  if (currentSP) {
                    detailsUserRole.selectedSalePoints.push(currentSP);
                  }
                }
              }
            }
          }
        });
      }

      Promise.all(promises).then(() => resolve());
    });
  }


  // async distributeSelectedUsersToRoles() {
  //   for (const detailsUser of this.details.users) {
  //     const detailsUserRole = this.roles.find(role => role.id === detailsUser.role_id);
  //     if (detailsUserRole) {
  //       const user = detailsUserRole.totalUsers.find(u => u.id === detailsUser.id);
  //       if (user) {
  //         detailsUserRole.selectedUsers.push(user);
  //
  //         //#region old by Greg
  //         // role.id === 4 ? 'inspector_id' : role.id === 5 ? 'regional_id' : 'user_id',
  //
  //         // for (const salePoint of detailsUser.sale_points) {
  //         //   let filter = detailsUserRole.id === 4 ? 'inspector_id' : detailsUserRole.id === 5 ? 'regional_id' : 'user_id';
  //         //   filter += ` = ${user.id} AND id = ${salePoint.id}`;
  //         //   const userDetailsSalePoint = await this.commonService.getListWithParameters(`sale_point/simple`, `${filter}`);
  //         //   const sp = userDetailsSalePoint[0];
  //         //   sp.user_id = user.id;
  //         //   detailsUserRole.selectedSalePoints.push(sp);
  //         // }
  //         //#endregion
  //         let filter;
  //         filter = detailsUserRole.id === 4 ? 'inspector_id' : detailsUserRole.id === 5 ? 'regional_id' : 'user_id';
  //         filter += ` = ${user.id}`;
  //         if (this.categoryId !== 3) {
  //           this.dataSP = await this.commonService.getListWithParameters(`sale_point/simple`, `${filter}`);
  //           for (const salePoint of detailsUser.sale_points) {
  //             const currentSP = this.dataSP.find(sp => sp.id === salePoint.id);
  //             if (currentSP) {
  //               detailsUserRole.selectedSalePoints.push(currentSP);
  //             }
  //           }
  //         }
  //
  //         //#region old by Greg
  //         // const userDetailsSalePoints = await this.commonService.getListWithParameters(`sale_point`, `${filter}=${user.id}`) as [];
  //         // for (const salePoint of userDetailsSalePoints) {
  //         //   detailsUserRole.selectedSalePoints.push(salePoint);
  //         // }
  //         //#endregion
  //       }
  //     }
  //   }
  // }

  async getUsers() {
    await this.initUsers();
  }

  assignTo() {
    if (this.categoryId === 3) {
      const model = {
        category_id: this.categoryId,
        status_id: this.statusId,
        users: []
      };

      for (const role of this.roles) {
        for (const user of role.selectedUsers) {
          model.users.push({id: user.id, questionnaire_user_id: null});
        }
      }

      this.close(model);
    } else {
      const emptySalePointsForUsers = [];
      const model = {
        category_id: this.categoryId,
        status_id: this.statusId,
        users: [],
      };

      for (const role of this.roles) {
        for (const user of role.selectedUsers) {
          const userModel = {
            id: user.id,
            questionnaire_user_id: null,
            sale_points: [],
            sale_points_to_remove: []
          };

          for (const salePoint of role.selectedSalePoints) {
            if (salePoint.user_id === user.id) {
              userModel.sale_points.push(salePoint.id);
            }
          }

          if (role.salePointsForRemoval) {
            for (const salePoint of role.salePointsForRemoval) {
              if (salePoint.user_id === user.id) {
                userModel.sale_points_to_remove.push(salePoint.id);
              }
            }
          }
          model.users.push(userModel);
          const empty = role.selectedSalePoints.filter(salePoint => salePoint.user_id === user.id);
          if (empty.length === 0) {
            emptySalePointsForUsers.push({id: user.id, name: user.name});
          }
        }
      }


      if (emptySalePointsForUsers.length > 0) {
        let message = `Υπάρχουν επιλεγμένοι χρήστες χωρίς επιλεγμένα σημεία πώλησης. Παρακαλώ επιλέξτε σημεία πώλησης για τους χρήστες: `;
        for (const user of emptySalePointsForUsers) {
          message += `${user.name},`;
        }
        message.substring(0, message.length - 1);
        this.toastMessagesService.toastMessages(message);
      } else {
        this.close(model);
      }

    }
  }

  selectUsers(role: Role) {
    const roleSelectedUsers = this.matDialog.open(SelectionDialogComponent, {
      data: {
        title: 'Επιλέξτε χρήστη',
        mode: 0,
        users: role.totalUsers,
        selectedUsers: role.selectedUsers
      }
    });

    roleSelectedUsers.afterClosed().subscribe(users => {
      if (users) {
        // role.selectedUsers = users;
        role.selectedSalePoints = users.selected;
        role.salePointsForRemoval = users.forRemoval;
      }
    });
  }

  selectSalePoints(role: Role) {
    const selectedSalePoints = this.matDialog.open(SelectionDialogComponent, {
      data: {
        title: 'Επιλέξτε Σημείο Πώλησης',
        mode: 1,
        users: role.selectedUsers,
        filter: role.id === 4 ? 'inspector_id' : role.id === 5 ? 'regional_id' : 'user_id',
        selectedSalePoints: role.selectedSalePoints,
        categoryId: this.categoryId
      }
    });

    selectedSalePoints.afterClosed().subscribe(async (salePoints) => {
      if (salePoints) {
        role.selectedSalePoints = [];
        // role.selectedSalePoints = salePoints;
        role.selectedSalePoints = salePoints.selected;
        role.salePointsForRemoval = salePoints.forRemoval;
      }
    });
  }

  close(value?: any) {
    this.matDialogRef.close(value);
  }

  showError(e: any) {
    this.toastMessagesService.toastErrorMessage(e.message);
  }
}
